// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1i8zv","title":"ClientReferral_title__fya66","itemText":"ClientReferral_itemText__j1M1r"};